import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import '../assets/styles/pages/_portal-redirect.scss';

const PortalRedirect = () => {
    const [searchParams] = useSearchParams();
    const portalType = searchParams.get('portal'); // 'new' or 'legacy'

    useEffect(() => {
        const timer = setTimeout(() => {
            if (portalType === 'new') {
                // Redirect to new INow portal
                window.location.href = process.env.REACT_APP_INOW_PORTAL_URL || 'https://rvos-uat-sp.mu-1-us-west-2.guidewire.net';
            } else {
                // Redirect to legacy portal (my.rvos.com)
                window.location.href = process.env.REACT_APP_SIGN_IN_URI || process.env.REACT_APP_LEGACY_PORTAL_URL || 'https://my.rvos.com';
            }
        }, 3000); 

        return () => clearTimeout(timer);
    }, [portalType]);

    const portalName = portalType === 'new' ? 'New' : 'Legacy';

    return (
        <div className="portal-redirect-page">
            <div className="portal-redirect-container">
                <div className="portal-redirect-message">
                    You are being directed to the "{portalName}" customer portal.
                </div>
            </div>
        </div>
    );
};

export default PortalRedirect;

